import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppLink } from '../../common/appLinks/appLinksCfg.service';
import { AppLinkNavigatorService } from '../../common/appLinks/appLinkNavigator.service';
import { ShowPowerBiCfgService } from './../../common/launcher/powerbi/services/showPowerbi-cfg.service';

export enum CardWithModal {
  PowerBi = 200,
  Vacancies = 7274
}

@Component({
  selector: 'app-card',
  templateUrl: './appCard.component.html',
  styleUrls: ['./appCard.component.css'],
  standalone: false
})
export class AppCardComponent {
  public cardWithModal = CardWithModal;

  @Output() public powerBiDialog = new EventEmitter<void>();

  constructor(private appLinkNavigatorService: AppLinkNavigatorService,
    private showPowerBiCfgService: ShowPowerBiCfgService
  ) {
  }

  @Input() public appLink: AppLink;

  public onClick() {
    switch (this.appLink.resourceId) {
      case this.cardWithModal.PowerBi:
        if (this.showPowerBiCfgService.getCfg().show == "1") {
          this.powerBiDialog.emit();
        } else {
          this.appLinkNavigatorService.navigate(this.appLink);
        }
        break;
      case this.cardWithModal.Vacancies:
        window.open('vacancies', '_blank');
        break;
      default:
        this.appLinkNavigatorService.navigate(this.appLink);
    }
  }
}
